import React from 'react';

type Props = {
  total?: number;
  activeIndex: number;
};

export default function ProgressSteps({ total = 7, activeIndex }: Props) {
  return (
    <div id="progress-steps">
      {Array.from({ length: total }).map((_, index) => {
        const isActive = index < activeIndex;
        return (
          <div key={`step-${index}`} className="step" data-active={String(Boolean(isActive))} />
        );
      })}
    </div>
  );
}
